const errors = {
    422: "Invalid file format",
    8701: "This configuration has Auto Session Enabled, a Auto Session Time value is required;",
    9000: "Invalid Credentials",
    9001: "Missing Password",
    9012: "Token has no user",
    9020: "Token Expired",
    9060: "User already inactive",
    9061: "User already active",
    9062: "User e-mail missing",
    9063: "User missing password",
    9064: "User e-mail is invalid",
    9065: "User e-mail already exists",
    9066: "User password very common",
    9067: "User password too short",
    9068: "User password too simple",
    9072: "User does not exist",
    9080: "Multiple existing users",
    9081: "User password recovery mail failed",
    9090: "Password change limit reached",
    1000: "Hall missing name",
    1010: "Hall missing tag",
    1001: "Hall name already exists",
    1011: "Hall tag already exists",
    1020: "Hall missing address",
    1030: "Hall missing subsidiary",
    1100: "Hall does not exist",
    1200: "Subsidiary does not exist",
    1040: "Timezone not selected.",
    1500: "Selected timezone not recognized.",
    1300: "Missing server name",
    1301: "Server name duplicated",
    1302: "Server does not exist",
    1400: "Error generating configuration with new name. Hall edit failed.",
    1303: "Server missing Hall info",
    9035: "Name already exists for a role in this subsidiary",
    9003: "Current Password is incorrect.",
    14001: "Server Id not found.",
    14002: "Wrong file. Expecting a Seed file.",
    14003: "Seed file is invalid.",
    14004: "Seed file as an unkown Server Id",
    14005: "Missing license duration.",
    14006: "Error Downloading License.",
    14007: "License does not exist.",
    14101: "Server License state does not exist.",
    14102: "Invalid state transition.",
    14103: "In current state this action can not be perfomed.",
    14104: "Licenses is expired.",
    14105: "Missing server expecting approval.",
    1304: "Missing specification file.",
    1305: "Server Identifier not correct. Validate if specification is from this server.",
    1306: "This system specification was already uploaded.",
    1201: "No permission for this access.",
    10920: "Subsidiary not recognized.",
    10702: "Duplicated game name.",
    10603: "Game with same attributes already exists.",
    11001: "Mailing list name from subsidiary already exists.",
    11002: "Preset does not exist",
    10700: "Game does not exit.",
    8005: "System Server version not exit.",
    8006: "Server hasn't been initiated. Missing External ID.",
    8007: "This is an offline server",
    8100: "Missing settings in configuration.",
    10257: "BundleID already exists",
};

export default errors;
